import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FILTER_MANAGER_ROLES = ["super_admin", "sales_head", "management", "region_head", "sales_manager"];

export function SalespersonFilter({ value, onChange, testid = "salesperson-filter", width = "w-[170px]" }) {
  const { user } = useAuth();
  const allowed = FILTER_MANAGER_ROLES.includes(user?.role);
  const { data } = useQuery({
    queryKey: ["team-members"],
    queryFn: async () => (await api.get("/team-activity/members")).data,
    enabled: allowed,
    staleTime: 300000,
  });
  if (!allowed) return null;
  const members = (data?.members || []).filter((m) => m.id !== user?.id || true);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`h-9 ${width}`} data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All salespeople</SelectItem>
        {members.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
